// Earliest date/time a DOCTOR/ADMIN may book or reschedule, derived from their
// per-doctor calendar setting (doctor_settings.pastDateRestriction /
// pastDateWindowDays).
//
// Default (restriction ON, or no settings) returns `now` unchanged — so existing
// strict behavior is preserved exactly. When the doctor turns the restriction
// OFF, it returns `now - windowDays` (or epoch for unlimited, windowDays === -1).
//
// NOTE: patients must NOT use this — the patient flow stays restricted to >= now.
export const getDoctorPastBoundary = (doctorSettings, now = new Date()) => {
    if (!doctorSettings || doctorSettings.pastDateRestriction !== false) return now;
    const w = Number(doctorSettings.pastDateWindowDays);
    if (w === -1) return new Date(0); // unlimited — any past date allowed
    const days = Number.isFinite(w) ? w : 0;
    return new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
};

export default getDoctorPastBoundary;
